import React from 'react';

import './multiSelectTitle.scss';

import PropTypes from 'prop-types';

export class MultiSelectTitle extends React.Component {

    static contextTypes = {
        titleText: PropTypes.string,
        selectionCount: PropTypes.number,
        translator: PropTypes.func
    };

    constructor (props) {
        super(props);
    }

    render () {
        const {
            titleText,
            selectionCount
        } = this.props;

        return (
            <div className="multiSelectTitleComponent ">
                <div className="selectionCount">{selectionCount}</div>
                <div className="titleText">{titleText}</div>
            </div>
        );
    }
}

